import { AdvancedMarker, Pin } from "@vis.gl/react-google-maps";


const CinemaMarker = ({ cinema }) => {

    //Change pin colors based on cinema type
    const numetro_colors = {
        background: "#E6852A",
        borderColor: "#000000",
        glyphColor: "#FFFFFF"
    }

    const sk_colors = {
        background: "#4B99FD",
        borderColor: "#000000",
        glyphColor: "#FFFFFF"
    }

    return (
        <AdvancedMarker
            key={cinema.id}
            position={{
                lat: parseFloat(cinema.lat),
                lng: parseFloat(cinema.lng)
            }}
            title={cinema.name}
        >
            <Pin
                {...cinema.provider === "numetro" ? numetro_colors : sk_colors}
            />
        </AdvancedMarker>
    );
}

export default CinemaMarker;